import { Button, message, Modal } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteAccount } from "../controller/services/auth";
import i18n from "../localization/i18n";
import { setLoading } from "../redux/slices/common_slice";
import { setUserData } from "../redux/slices/user_slice";
import { routePaths } from "../routing/routePaths";
import { clearLocalStoragenNavigate } from "../utils/helper";

const DeleteAccountModal = ({ open, onClose }) => {
  const [loading, setLoadingLocal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deleteAccountHandler = () => {
    setLoadingLocal(true);
    dispatch(setLoading(true));
    deleteAccount()
      .then(() => {
        onClose();
        setTimeout(
          () =>
            clearLocalStoragenNavigate(
              dispatch,
              navigate,
              setUserData,
              onClose,
              routePaths.signUp
            ),
          1000
        );
      })
      .catch((Err) => {
        message.error(Err.message[i18n.language]);
      })
      .finally(() => {
        setLoadingLocal(false);
        dispatch(setLoading(false));
      });
  };

  return (
    <>
      <Modal
        width="368px"
        title={false}
        open={open}
        onOk={onClose}
        onCancel={onClose}
        className="custom-common-modal"
        centered
        closeIcon={false}
        footer={false}
      >
        <div className="row modal-main-inner-row">
          <div className="col-12 text-center">
            <img
              src="/assets/images/icons/delete-account-icon.svg"
              className="img-fluid"
              alt=""
            />
            <p className="auth-modal-descripation">
              {t("settings.confirmationMsg")}
            </p>
            <div className="row modal-footer-row mt-0">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Button onClick={deleteAccountHandler} loading={loading}>
                  {t("settings.yes")}
                </Button>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Button type="primary" onClick={onClose}>
                  {t("settings.no")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeleteAccountModal;
